import AttachFileIcon from '@mui/icons-material/AttachFile';
import { IconButton, Tooltip } from '@mui/material';
import * as React from 'react';
import { useAppDispatch } from '../../../store/hooks';
import { setMediaDrawer } from '../../../store/media';

export default function MenuAttachFile() {
    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(setMediaDrawer({ mediaDrawer: true }));
    };
    return (
        <React.Fragment>
            <Tooltip title="Attach file">
                <IconButton onClick={handleClick} aria-controls="attach_file_menu">
                    <AttachFileIcon />
                </IconButton>
            </Tooltip>
        </React.Fragment>
    );
}
